<div class="row">
  <div class="col-12">
    <sb-card [loading]="loading">
      <div card-fit>
        <sb-wizard [hideTabs]="true" [clickableTabs]="false" classes="wizard__minHeightSetting">
          <sb-wizard-tab>
            <form [formGroup]="form" class="wizard__forms p-5">
              <div class="row">
                <div class="col-md-6">
                  <div class="form-group validateMe">
                    <label class="form-label" for="Title">{{'lang.globals.name' | translate}}<span class="red">*</span></label>
                    <input type="text" id="Title" class="form-control" formControlName="Name" sbAutofocus>
                    <div *ngIf="Name.touched && Name.errors?.required"
                         class="alert alert-danger">{{'lang.globals.nameWarning' | translate}}</div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group validateMe">
                    <label class="form-label" for="EMail">{{'lang.globals.email' | translate}}</label>
                    <input type="text" id="EMail" class="form-control" formControlName="EMail">
                    <div *ngIf="EMail.touched && EMail.errors?.required"
                         class="alert alert-danger">{{'lang.globals.emailRequest' | translate}}</div>
                  </div>
                </div>

                <div class="col-md-6">
                  <div class="form-group validateMe">
                    <label class="form-label" for="Identifier">{{'lang.globals.uniqueIdentifier' | translate}}</label>
                    <input type="text" id="Identifier" class="form-control" formControlName="Identifier">
                    <div *ngIf="Identifier.touched && Identifier.errors?.required"
                         class="alert alert-danger">{{'lang.globals.uniqueIdentifierWarning' | translate}}</div>
                  </div>
                </div>
              </div>
              <hr class="border-dashed">
              <sb-comp-address-component
                *ngIf="!loading && client?.primaryCompany?.address"
                [point]="point" [address]="client?.primaryCompany?.address"
                (pointEmitter)="point = $event"
                (addressEmitter)="client.primaryCompany.address = $event">
              </sb-comp-address-component>
              <div class="wizard__footerActions">
                <a [sbRouterLink]="util.RoutingID.adminClientManagement"
                   class="btn btn-default btn-wizard"
                   type="button">{{'lang.globals.cancel' | translate}}</a>
                <button (click)="ok()" [disabled]="!form.valid || loading" class="btn btn-primary btn-wizard"
                        type="button">
                  {{'lang.globals.submit' | translate}}</button>
              </div>
            </form>
          </sb-wizard-tab>
        </sb-wizard>
      </div>
    </sb-card>
  </div>
</div>
